export const enum ChecklistActions {
    EDIT = 'edit',
    COPY = 'copy',
    DELETE = 'delete',
}
